/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  apiUrl: 'https://food-order-cms.selfmaker.pl:8443/api',
  storage: 'https://food-order-cms.selfmaker.pl:8443/storage/'
};
